export const DEFAULT_POLLING_INTERVAL = 5000;
